module.exports = __webpack_public_path__ + "img/lg_ring_r_0_null_null@3x.5b2fce31.png";